import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import queryString from 'query-string';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import Tree from '../tree';
import {request} from '../../containers/actions';
import Note from './note.js';
import NoteForm from './note_form.js';
import { SSO_login } from '../../utilities/requests.js';
import { request_sso_login } from '../sso_callback/sso.js';

export default class Notes extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        filters: {},
    }

    state = {
        add: false,
        notes: [],
    }

    items = [
        {
            page: undefined,
            query: {confirmed: 'True'},
            label: window.gettext('All Notes'),
            icon: 'plus',
            editable: false,
        },
        {
            page: 'bookmarked',
            query: {confirmed: 'True', bookmarked: 'True'},
            label: window.gettext('Bookmarked'),
            icon: 'plus',
            editable: false,
        },
        {
            page: 'following',
            query: {confirmed: 'True', following: 'True'},
            label: window.gettext('Following'),
            icon: 'plus',
            editable: false,
        },
        {
            page: 'favored',
            query: {confirmed: 'True', o: '-likes'},
            label: window.gettext('Favored'),
            icon: 'plus',
            editable: false,
        },
        {
            page: 'mine',
            query: {author: this.context.user.id},
            label: window.gettext('My Notes'),
            icon: 'plus',
            editable: true,
        },
    ]

    componentDidMount() {
        this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.params.page, this.props.params.page))
            this.fetch.bind(this)();
    }

    async fetch() {
        this.setState({
            notes: [],
            count: 0,
        });
        const activeItem = _.find(this.items, item => item.page === this.props.params.page);
        const response = await this.context.store.dispatch(request({
            path: '/note/?' + queryString.stringify({...activeItem.query, chapter: this.props.chapter}),
        }));
        this.setState({
            notes: response.results,
            count: response.count,
        });
    }

    async fetchMore() {
        const activeItem = _.find(this.items, item => item.page === this.props.params.page);
        const response = await this.context.store.dispatch(request({
            path: '/note/?' + queryString.stringify({
                ...activeItem.query,
                offset: this.state.notes.length,
            }),
        }));
        this.setState(update(this.state, {
            notes: {$push: response.results},
            count: {$set: response.count},
        }));
    }

    renderNotes(page) {
        if (this.state.add)
            return <div>
                <NoteForm
                    chapter={this.props.chapter}
                    noteTypeTree={this.props.noteTypeTree}
                    onFinished={() => {
                        this.setState({add: false});
                        this.fetch();
                    }}
                />
            </div>;
        const activeItem = _.find(this.items, item => item.page === page);
        return <div style={{height: 'calc(100% - 1.5em)', paddingLeft: '.5em', paddingTop: '1.5em', overflowY: 'auto'}}>
            {page === 'mine'
                ? <button
                    style={styles.defaultButton}
                    onClick={() => this.setState({add: true})}>
                    {window.gettext('Add Note')}
                </button>
                : null
            }
            {_.map(
                this.state.notes,
                (note, index) => <Note
                    key={note.id}
                    data={note}
                    index={index}
                    editable={activeItem.editable}
                    open={this.state.open === note.id}
                    refresh={this.fetch.bind(this)}
                    toggle={() => this.setState({open: this.state.open === note.id ? undefined : note.id})}
                />,
            )}
            {this.state.notes.length < this.state.count
                ? <div
                    style={{cursor: 'pointer', textAlign: 'center'}}
                    onClick={this.fetchMore.bind(this)}>
                    {window.gettext('More')}
                </div>
                : null
            }
        </div>;
    }

    render() {
        const authenticated = this.context.store.getState().getIn(['application', 'token', 'accessToken']);
        return <div>
            <div style={{display: 'none'}}>
                <Tree
                    store={this.props.noteTypeTree}
                    resource='note-type'
                    itemLabel='label'
                />
            </div>
            <div
                style={{
                    float: 'left',
                    width: '9em',
                }}>
                {_.map(
                    this.items,
                    (item, index) => {
                        const active = authenticated ? this.props.params.page === item.page : item.page === undefined;
                        return <div
                            key={index}
                            style={{
                                boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                                padding: '.5em',
                                boxSizing: 'border-box',
                                borderRadius: '.2em',
                                float: 'left',
                                width: '8em',
                                backgroundColor: active ? styles.secondaryColor : 'white',
                                cursor: 'pointer',
                                zIndex: '0',
                            }}
                            onClick={() => {
                                if (!authenticated) {
                                    if(SSO_login){
                                        request_sso_login();
                                    }
                                    this.context.store.dispatch(push({
                                        ...this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS(),
                                        query: {
                                            dialog: 'login',
                                            'login_message': btoa(unescape(encodeURIComponent(
                                                window.gettext('In order to use this section you should be logged in.'),
                                            ))),
                                        },
                                    }));
                                    return;
                                }   
                                if (!active) {
                                    this.setState({add: false});
                                    const path = this.context.store.getState().getIn(
                                        ['routing', 'locationBeforeTransitions', 'pathname'],
                                    );
                                    this.context.store.dispatch(push(path.split('/').slice(0, this.props.params.page ? -2 : -1).
                                        join('/') + '/' + (item.page ? `${item.page}/` : '')));
                                }
                            }}>
                            <div
                                style={{
                                    position: 'relative',
                                    color: 'black',
                                    padding: '.3em',
                                    marginBottom: '.5em',
                                    textAlign: 'center',
                                }}>
                                {item.label}
                            </div>
                            <i style={{width: '100%', textAlign: 'center'}} className={`fa fa-${item.icon} fa-lg`}></i>
                        </div>;
                    },
                )}
            </div>
            <div style={{float: 'right', width: 'calc(100% - 9em)'}}>
                {this.renderNotes(authenticated ? this.props.params.page : undefined)}
            </div>
        </div>;
    }
}
